import { useState } from 'react';
import { Link } from 'react-router-dom';

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <h1>
              <img
                src="https://static.readdy.ai/image/a9d6aff03562300b57162884cb61551b/7fbf09dbcfaa601672c5e7d5615b1c01.png"
                alt="Revivacorp"
                className={`h-36 w-auto transition-all ${isScrolled ? 'brightness-0' : 'brightness-0 invert'}`}
              />
            </h1>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/services"
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              Services
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              About Us
            </Link>
            <Link
              to="/resources"
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              Resources
            </Link>
            <Link
              to="/contact"
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              Contact Us
            </Link>
            <Link to="/contact">
              <button className="px-6 py-2.5 bg-teal-500 text-white text-sm font-medium rounded-full hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                Get Started
              </button>
            </Link>
          </div>

          <button
            className="md:hidden cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i
              className={`ri-menu-line text-2xl ${
                isScrolled ? 'text-slate-900' : 'text-white'
              }`}
            ></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-white shadow-lg rounded-lg mt-2 py-4 px-6 space-y-4">
            <Link
              to="/services"
              className="block text-sm font-medium text-slate-700 hover:text-teal-500"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Services
            </Link>
            <Link
              to="/about"
              className="block text-sm font-medium text-slate-700 hover:text-teal-500"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              About Us
            </Link>
            <Link
              to="/resources"
              className="block text-sm font-medium text-slate-700 hover:text-teal-500"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Resources
            </Link>
            <Link
              to="/contact"
              className="block text-sm font-medium text-slate-700 hover:text-teal-500"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Contact Us
            </Link>
            <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>
              <button className="w-full px-6 py-2.5 bg-teal-500 text-white text-sm font-medium rounded-full hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                Get Started
              </button>
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}